"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _InputField = _interopRequireDefault(require("./InputField"));

var _InputValidation = _interopRequireDefault(require("./InputValidation"));

require("./EmailField.less");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"!'#$%^&*]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z0-9-]+\.)+[a-zA-Z-]{2,}))$/;

var EmailField = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(EmailField, _React$Component);

  var _super = _createSuper(EmailField);

  function EmailField(props) {
    (0, _classCallCheck2.default)(this, EmailField);
    return _super.call(this, props);
  }

  (0, _createClass2.default)(EmailField, [{
    key: "validate",
    value: function validate(value) {
      var valid = EMAIL_REGEX.test(value);
      var message = valid ? null : 'Email must be valid.';
      return {
        valid: valid,
        message: message
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onValidate = _this$props.onValidate,
          required = _this$props.required,
          fieldProps = (0, _objectWithoutProperties2.default)(_this$props, ["onValidate", "required"]);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "primitive-email-field"
      }, /*#__PURE__*/_react.default.createElement(_InputValidation.default, {
        onValidate: onValidate,
        validate: this.validate,
        required: required
      }, /*#__PURE__*/_react.default.createElement(_InputField.default, fieldProps)));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return _objectSpread({
        onValidate: _propTypes.default.func
      }, _InputField.default.propTypes);
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return _objectSpread({
        onValidate: function onValidate() {}
      }, _InputField.default.defaultProps);
    }
  }]);
  return EmailField;
}(_react.default.Component);

exports.default = EmailField;